import { render, staticRenderFns } from "./GridGamesScore1x1.vue?vue&type=template&id=6c0efbf9&scoped=true&"
import script from "./GridGamesScore1x1.vue?vue&type=script&lang=js&"
export * from "./GridGamesScore1x1.vue?vue&type=script&lang=js&"
import style0 from "./GridGamesScore1x1.vue?vue&type=style&index=0&id=6c0efbf9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0efbf9",
  null
  
)

export default component.exports